/**
 * The three non-content states a card can be in.
 *
 * Unified because the audit found six different loading treatments, three
 * empty and three error -- including one tab with no loading state at all, two
 * identical shimmer keyframes under different names, and both "Could not
 * load..." and "Couldn't load..." in use. The contraction wins: it matches the
 * two most recently written components.
 *
 * A loading state carries BOTH aria-busy and aria-label. Without the label a
 * screen reader announces nothing while the region is busy.
 */
// `retry`: the card shows its own "Try again" button, so the error line must
// not also tell people to refresh the page.
export default function CardState({ kind, label, thing, lines = 3, retry = false, children }) {
  if (kind === 'loading') {
    return (
      <div className="pf-skeleton" aria-busy="true" aria-label={label}>
        {Array.from({ length: lines }, (_, i) => (
          <span key={i} className="pf-skeleton__line" />
        ))}
      </div>
    );
  }

  if (kind === 'error') {
    return (
      <p className="profile-muted profile-info-card__empty">
        Couldn&apos;t load {thing}.{retry ? '' : ' Refresh to try again.'}
      </p>
    );
  }

  return <p className="profile-muted profile-info-card__empty">{children}</p>;
}
